<template>
  <div>
    <button class="geo-header" @click="$modal.show('geo-modal')">
      <svg class="geo-header__svg-desktop"
           width="10"
           height="13"
           viewBox="0 0 10 13"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.46962 12.8358C5.46962 12.8358 9.98066 9.09163 9.98066 5.04885C9.98066 2.26044 7.74639 0 4.99034 0C2.23428 0 5.01922e-05 2.26044 0 5.04885C0 9.09163 4.51105 12.8358 4.51105 12.8358C4.77464 13.0546 5.20602 13.0546 5.46962 12.8358ZM4.98993 7.92893C6.49694 7.92893 7.71863 6.69364 7.71863 5.16984C7.71863 3.64605 6.49694 2.41078 4.98993 2.41078C3.48291 2.41078 2.26123 3.64605 2.26123 5.16984C2.26123 6.69364 3.48291 7.92893 4.98993 7.92893Z"
              fill="white"/>
      </svg>
      <svg class="geo-header__svg-mobile"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.65535 1.97676C9.98164 1.02085 12.6298 1.56163 14.3815 3.3455L14.3814 3.34558L14.3908 3.35481C15.5592 4.50368 16.179 6.12041 16.179 7.80355C16.179 9.01357 15.7636 10.2893 15.1246 11.5295C14.489 12.7632 13.6559 13.9163 12.8753 14.8706C11.9852 15.9344 11.0339 16.9576 10.0218 17.8847C8.99504 16.9528 8.00994 15.9283 7.12492 14.8706C6.34603 13.9184 5.51239 12.7537 4.87617 11.5133C4.23588 10.2649 3.82117 8.98932 3.82117 7.80355C3.82117 5.25488 5.3404 2.92801 7.65535 1.97676ZM7.08523 0.589327C9.97074 -0.596378 13.2656 0.0720131 15.4472 2.28985C16.9282 3.74881 17.679 5.76284 17.679 7.80355C17.679 9.34145 17.1568 10.8602 16.458 12.2165C15.7565 13.5781 14.8528 14.8224 14.0335 15.8237L14.0284 15.8299L14.0284 15.8299C12.9577 17.1099 11.7865 18.3514 10.5144 19.4549L10.0229 19.8813L9.53148 19.4549C8.26637 18.3575 7.04924 17.118 5.97178 15.8299L5.96659 15.8237L5.96662 15.8237C5.14551 14.8202 4.24234 13.5643 3.54149 12.1979C2.84403 10.838 2.32117 9.31912 2.32117 7.80355C2.32117 4.67006 4.18635 1.78053 7.08523 0.589327ZM7.11401 7.70989C7.11401 6.05337 8.42915 4.73389 10.0228 4.73389C11.6165 4.73389 12.9317 6.05337 12.9317 7.70989C12.9317 9.36641 11.6165 10.6859 10.0228 10.6859C8.42915 10.6859 7.11401 9.36641 7.11401 7.70989ZM10.0228 3.23389C7.57511 3.23389 5.61401 5.25078 5.61401 7.70989C5.61401 10.169 7.57511 12.1859 10.0228 12.1859C12.4706 12.1859 14.4317 10.169 14.4317 7.70989C14.4317 5.25078 12.4706 3.23389 10.0228 3.23389Z"
          fill="#FF2F00"/>
      </svg>

      <span class="geo-header__city-text">{{ $t('city') }}</span>
      <span class="geo-header__city-name">{{ cityName }}</span>
    </button>
    <GeoPopup v-if="isGeoPopupShown && !popupClosed && potentialUserCity && potentialUserCity.name_ru" @closePopup="popupClosed = true"/>
  </div>
</template>

<script>
import GeoPopup from './GeoPopup'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'GeoHeader',
  components: { GeoPopup },
  data () {
    return {
      popupClosed: false
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'getActualUserCity', 'isUkLanguage']),
    ...mapState({
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      isGeoPopupShown: state => state.geoLocation.isGeoPopupShown,
      potentialUserCity: state => state.geoLocation.potentialUserCity
    }),
    cityName () {
      if (this.selectedUserLocation) {
        return this.isUkLanguage ? this.selectedUserLocation.name_uk : this.selectedUserLocation.name_ru
      } else {
        return this.$t('city')
      }
    }
  }
}
</script>

<style lang="sass">
.geo-header-wrapper
  position: relative
</style>
<style scoped lang="sass">

.geo-header
  padding: 15px 0
  font-family: 'Cera Pro', Roboto, Helvetica, Arial, sans-serif
  border: 0
  background: transparent
  display: flex
  flex-wrap: nowrap
  width: 100%
  align-items: center

  &:hover
    .geo-header__city-text
      color: $main-color

  +mmin(1024)
    padding: 0

.geo-header__city-name
  font-size: 14px
  line-height: 18px
  text-overflow: ellipsis
  white-space: nowrap
  display: block
  overflow: hidden
  color: #878787
  max-width: 100px
  margin-left: auto

  +mmin(1024)
    color: white
    margin-left: 8px
    max-width: 70px
    font-size: 12px
    margin-top: 1px

  +mmin(1301)
    max-width: 90px
    font-size: 14px
    margin-top: 0

.geo-header-wrapper
  position: relative

.geo-header__svg-desktop
  display: none

  +mmin(1024)
    display: block

.geo-header__svg-mobile
  +mmin(1024)
    display: none

.geo-header__city-text
  font-size: 14px
  color: $text-color
  margin-left: 20px

  +mmin(1024)
    display: none

</style>
